// extracted by mini-css-extract-plugin
module.exports = {"postBlock":"PageView_postBlock__BklX_"};